module.exports = __webpack_public_path__ + "img/hero-2.81c314da.png";